import config from './config';

const awsConfig = {
    aws_cognito_region: config.awsCognitoRegion,
    userPoolId: config.awsUserPoolId,
    userPoolWebClientId: config.awsUserPoolWebClientId,
};

export default awsConfig;
